import AddressAppResource from './AddressAppResource';
import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import InquiryPropertyStatusAppResource from './InquiryPropertyStatusAppResource';
import InquiryPropertySubtypeAppResource from './InquiryPropertySubtypeAppResource';
import InquiryPropertyTypeAppResource from './InquiryPropertyTypeAppResource';
import MLSAppResource from './MLSAppResource';
import UserAppResource from './UserAppResource';

class InquiryAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Inquiry';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'inquiries';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'channel',
            'message',
            'firstName',
            'lastName',
            'jornayaLeadId',
            'propertyName',
            'bedrooms',
            'bathrooms',
            'propertySize',
            'propertySizeUnit',
            'lotSize',
            'lotSizeUnit',
            'listingUrl',
            'daysOnMarket',
            'listingDate',
            'addressUuid',
            'mlsUuid',
            'userUuid',
            'inquiryPropertyTypeUuid',
            'inquiryPropertySubtypeUuid',
            'inquiryPropertyStatusUuid',
            'address',
            'mls',
            'user',
            'propertyType',
            'propertySubtype',
            'propertyStatus',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            address: AddressAppResource,
            mls: MLSAppResource,
            user: UserAppResource,
            propertyType: InquiryPropertyTypeAppResource,
            propertySubtype: InquiryPropertySubtypeAppResource,
            propertyStatus: InquiryPropertyStatusAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            address: 'address_uuid',
            mls: 'mls_uuid',
            user: 'user_uuid',
            propertyType: 'inquiry_property_type_uuid',
            propertySubtype: 'inquiry_property_subtype_uuid',
            propertyStatus: 'inquiry_property_status_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            channel: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            message: {
                type: 'string',
                length: {
                    minimum: 1,
                },
            },
            firstName: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            lastName: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            jornayaLeadId: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            propertyName: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            addressUuid: {
                type: 'string',
            },
            inquiryPropertyTypeUuid: {
                type: 'string',
            },
            inquiryPropertySubtypeUuid: {
                type: 'string',
            },
            inquiryPropertyStatusUuid: {
                type: 'string',
            },
            bedrooms: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            bathrooms: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            propertySize: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            propertySizeUnit: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            lotSize: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            lotSizeUnit: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            listingUrl: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            daysOnMarket: {
                numericality: true,
            },
            listingDate: {
                type: 'string',
                datetime: true,
            },
            mlsUuid: {
                type: 'string',
            },
            userUuid: {
                type: 'string',
            },
        };
    }

}

export default InquiryAppResource;
